import { motion } from "framer-motion";

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const HudCorners = ({ className = "border-emerald/60" }) => (
  <>
    <span aria-hidden className={`pointer-events-none absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 ${className}`} />
    <span aria-hidden className={`pointer-events-none absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 ${className}`} />
    <span aria-hidden className={`pointer-events-none absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 ${className}`} />
    <span aria-hidden className={`pointer-events-none absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 ${className}`} />
  </>
);

export const Eyebrow = ({ children }) => (
  <p className="font-mono-tech text-xs uppercase tracking-[0.28em] text-emerald/90 flex items-center gap-3">
    <span className="inline-block w-8 h-px bg-emerald/70" />
    {children}
  </p>
);

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);
